export const i18nValidationNS = 'validation'
export const i18nCommonNS = 'common'
export const i18nErrorNS = 'error'
export const i18nLoginNS = 'login'
export const i18nFormNS = 'project'
